import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Navigate
} from 'react-router-dom';
import Login from './components/Login';
import Register from './components/Register';
import VerifyEmail from './components/VerifyEmail';
import TablePitches from './components/TablePitches';
import TableInsolvencyAgents from './components/TableInsolvencyAgents';
import AgentMergeConflicts from './components/AgentMergeConflicts';
import TableDeclarations from './components/TableDeclarations';
import TableDeclarationsBin from './components/TableDeclarationsBin';
import TablePitchHistory from './components/TablePitchHistory';
import "./App.css";
import "./styles/Table.css";
import "./styles/Auth.css";
import "./styles/Button.css";
import "./styles/Animation.css";
import "./styles/PageOverlay.css";
import "./styles/Sidebar.css";
import "./styles/Messages.css";
import "./styles/Popup.css";
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';

function ProtectedRoute({ user, loading, children }) {
  if (loading) {
    return <p>Loading...</p>;
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/auth/me')
      .then(response => {
        if (response.ok) return response.json();
        throw new Error('Not logged in');
      })
      .then(data => {
        setUser(data.user);
        setLoading(false);
      })
      .catch(err => {
        console.log('User not logged in');
        setLoading(false);
      });
  }, []);

  const handleLogout = () => {
    fetch('/api/auth/logout', { method: 'POST' })
      .then(() => setUser(null))
      .catch(err => console.error('Logout failed', err));
  };

  return (
    <Router>
      <div>        
        {user ? (
          <>
            <nav className="nav">
              <p>Logged in as {user.email}</p>
              <ul>
                <li>
                  <NavLink to="/register1">Declarations</NavLink>
                </li>
                <li>
                  <NavLink to="/register2">Pitches</NavLink>
                </li>
                <li>
                  <NavLink to="/register3">Insolvency Agents</NavLink>
                </li>
                <li>
                  <NavLink to="/register4">History</NavLink>
                </li>
              </ul>
              <button className="logout-button" onClick={handleLogout}>Logout</button>
            </nav>
          </>
        ) : null}

        <Routes>
          <Route
            path="/login"
            element={
              loading ? <p>Loading...</p> : user ? <Navigate to="/register1" replace /> : <Login onLogin={setUser} />
            }
          />
          <Route
            path="/register"
            element={
              loading ? <p>Loading...</p> : user ? <Navigate to="/register1" replace /> : <Register />
            }
          />
          
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          <Route path="/verify-email/:token"
           element={<VerifyEmail />
           } />

          <Route
            path="/register1"
            element={
              <ProtectedRoute user={user} loading={loading}>
                <TableDeclarations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bin"
            element={
              <ProtectedRoute user={user} loading={loading}>
                <TableDeclarationsBin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/register2"
            element={
              <ProtectedRoute user={user} loading={loading}>
                <TablePitches />
              </ProtectedRoute>
            }
          />
          <Route
            path="/register3"
            element={
              <ProtectedRoute user={user} loading={loading}>
                <TableInsolvencyAgents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/merge"
            element={
              <ProtectedRoute user={user} loading={loading}>
                <AgentMergeConflicts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/register4"
            element={
              <ProtectedRoute user={user} loading={loading}>
                <TablePitchHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path="/"
            element={
              loading ? (
                <p>Loading...</p>
              ) : user ? (
                <Navigate to="/register1" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
